var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgArrowLeftCircleFilled = function SvgArrowLeftCircleFilled(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4851_1006y)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 34C7.61116 34 8.20799e-07 26.3888 0 17C-8.20798e-07 7.61116 7.61116 8.20798e-07 17 0C26.3888 -8.20799e-07 34 7.61116 34 17C34 26.3888 26.3888 34 17 34ZM16.293 23.707C16.6835 24.0976 17.3165 24.0976 17.707 23.707C18.0976 23.3165 18.0976 22.6835 17.707 22.293L13.4141 18H23C23.5523 18 24 17.5523 24 17C24 16.4477 23.5523 16 23 16H13.4141L17.707 11.707C18.0976 11.3165 18.0976 10.6835 17.707 10.293C17.3165 9.90244 16.6835 9.90244 16.293 10.293L10.293 16.293C9.90244 16.6835 9.90244 17.3165 10.293 17.707L16.293 23.707Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4851_1006y"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgArrowLeftCircleFilled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "arrow-left-circle-filled.2484a42f9686e7caa353a3d8c5be59ce.svg";